import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Instagram } from 'lucide-react';
import { contactInfo } from '../utils/mockData';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-br from-gray-900 to-gray-800 text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <div className="flex items-center mb-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_crystal-clean-3/artifacts/9lkjx49b_logo-xl.png" 
                alt="Tom The Window Cleaner" 
                className="h-12 w-auto"
              />
            </div>
            <div className="flex space-x-3">
              <a 
                href="https://instagram.com/tomthewindowcleaner" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-9 h-9 rounded-lg bg-gray-700 hover:bg-gradient-to-br hover:from-purple-600 hover:to-pink-600 flex items-center justify-center transition-all duration-300"
                aria-label="Follow us on Instagram"
              >
                <Instagram className="w-4 h-4" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-300 hover:text-cyan-400 transition-colors text-sm">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-300 hover:text-cyan-400 transition-colors text-sm">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/estimates" className="text-gray-300 hover:text-cyan-400 transition-colors text-sm">
                  Estimates
                </Link>
              </li>
              <li>
                <Link to="/gallery" className="text-gray-300 hover:text-cyan-400 transition-colors text-sm">
                  Gallery
                </Link>
              </li>
              <li>
                <Link to="/coverage" className="text-gray-300 hover:text-cyan-400 transition-colors text-sm">
                  Areas We Cover
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-300 hover:text-cyan-400 transition-colors text-sm">
                  Contact Us
                </Link>
              </li>
              <li>
                <Link to="/admin/login" className="text-gray-600 hover:text-gray-400 transition-colors text-xs">
                  Admin
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Our Services</h3>
            <ul className="space-y-2">
              <li className="text-gray-300 text-sm">Window Cleaning</li>
              <li className="text-gray-300 text-sm">Gutter Cleaning</li>
              <li className="text-gray-300 text-sm">Pressure Washing</li>
              <li className="text-gray-300 text-sm">Soft Washing</li>
              <li className="text-gray-300 text-sm">Solar Panel Cleaning</li>
              <li className="text-gray-300 text-sm">Commercial Services</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Contact Us</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <Phone className="w-5 h-5 text-cyan-400 flex-shrink-0 mt-0.5" />
                <div>
                  <a 
                    href={`tel:${contactInfo.phone.replace(/\s/g, '')}`} 
                    className="text-gray-300 text-sm hover:text-cyan-400 transition-colors cursor-pointer"
                    onClick={() => {
                      if (window.gtag) {
                        window.gtag('event', 'phone_click', {
                          'event_category': 'Contact',
                          'event_label': 'Footer Phone Click'
                        });
                      }
                    }}
                  >
                    {contactInfo.phone}
                  </a>
                </div>
              </li>
              <li className="flex items-start space-x-3">
                <Mail className="w-5 h-5 text-cyan-400 flex-shrink-0 mt-0.5" />
                <div>
                  <a href={`mailto:${contactInfo.email}`} className="text-gray-300 text-sm hover:text-cyan-400 transition-colors cursor-pointer break-all">
                    {contactInfo.email}
                  </a>
                </div>
              </li>
              <li className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 text-cyan-400 flex-shrink-0 mt-0.5" />
                <div>
                  <p className="text-gray-300 text-sm">{contactInfo.address}</p>
                  <p className="text-gray-400 text-xs mt-1">{contactInfo.serviceRadius}</p>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-700 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm">
              © {currentYear} Tom The Window Cleaner. All rights reserved.
            </p>
            <Link 
              to="/admin/login" 
              className="text-gray-500 hover:text-gray-300 text-xs transition-colors"
            >
              Admin Login
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
